import {
  json as baseJson,
  info as baseInfo,
} from '../../Base/Signup_fortuneWheel'
import themeBase from './_themeBase'
import INDEX from './_index'

const info = JSON.parse(JSON.stringify(baseInfo))
const json = JSON.parse(JSON.stringify(baseJson))
const templateID = info.templateID + INDEX

info.templateID = templateID
info.priority = 10
info.name = '' + info.name
json.theme = themeBase.theme
json.templateID = templateID

// Apply theme-specific styling overrides
json.styling = {
  ...json.styling,
  backgroundColor: '#FEFEFE',
  backgroundImage: '',
}

// Set Monochrome-themed font
const monochromeFont = 'Roboto'

// Modify content items as needed
json.steps.forEach((step) => {
  step.contentItems = step.contentItems.map((item) => {
    if (item.type === 'headline') {
      item.content.text = 'Spin & Win: Exclusive Offers Await!'
      item.styling.fontFamily = monochromeFont
    }
    if (item.type === 'text') {
      item.content.text = '<p>Try your luck! <strong>Spin the wheel</strong> for a chance at exclusive discounts and offers!</p>'
      item.styling.fontFamily = monochromeFont
    }
    if (item.type === 'button') {
      item.content.text = 'Spin Now'
      item.styling.fontFamily = monochromeFont
    }
    if (item.type === 'field' || item.type === 'voucher') {
      item.styling.fontFamily = monochromeFont
    }
    return item
  })
})

export { json, info }
